import { render, staticRenderFns } from "./AccountRequests.vue?vue&type=template&id=0ec7c706&scoped=true&"
import script from "./AccountRequests.vue?vue&type=script&lang=js&"
export * from "./AccountRequests.vue?vue&type=script&lang=js&"
import style0 from "./AccountRequests.vue?vue&type=style&index=0&id=0ec7c706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec7c706",
  null
  
)

export default component.exports